import { render, staticRenderFns } from "./add_edit.vue?vue&type=template&id=4523ed1b&scoped=true&"
import script from "./add_edit.vue?vue&type=script&lang=js&"
export * from "./add_edit.vue?vue&type=script&lang=js&"
import style0 from "./add_edit.vue?vue&type=style&index=0&id=4523ed1b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4523ed1b",
  null
  
)

export default component.exports